// PanelOptionsDialog.tsx — Master panel routing dialog
// Equivalent to v11 md_dlg — lets user choose which panel subsystem to open
// Replaces the progcont routing mechanism from VLX mode

import DialogBase from './DialogBase';
import { useStore } from '../store/useStore';
import type { ActiveDialog } from '../types/panelvar';

const OPTIONS: { label: string; dialog: ActiveDialog; desc: string }[] = [
  { label: 'Panel Dimensions',      dialog: 'panel-dims',       desc: 'Width, height, thickness, elevations' },
  { label: 'Rough Openings',        dialog: 'rough-openings',   desc: 'Up to 4 rough framed openings' },
  { label: 'Windows',               dialog: 'windows',          desc: 'Up to 6 standard window openings' },
  { label: 'Man Doors',             dialog: 'man-doors',        desc: 'Up to 6 man-door cutouts' },
  { label: 'Dock Levelers',         dialog: 'dock-levelers',    desc: 'Up to 3 dock leveler blockouts' },
  { label: 'Rect Blockouts',        dialog: 'rect-blockouts',   desc: 'Up to 6 rectangular blockouts' },
  { label: 'Round Blockouts',       dialog: 'round-blockouts',  desc: 'Up to 6 round blockouts' },
  { label: 'Horiz Feature Strips',  dialog: 'horiz-features',   desc: 'Up to 19 horizontal reveal strips' },
  { label: 'Vert Feature Strips',   dialog: 'vert-features',    desc: 'Up to 19 vertical reveal strips' },
  { label: 'Pilasters',             dialog: 'pilasters',        desc: 'Panel-length pilasters / legs' },
  { label: 'Ledgers',               dialog: 'ledgers',          desc: 'Ledger beam pockets' },
  { label: 'Top Profile',           dialog: 'top-profile',      desc: 'Parapet / top edge profile' },
  { label: 'Footing Shapes',        dialog: 'footing-shapes',   desc: 'Footing haunch geometry' },
  { label: 'Side Slabs',            dialog: 'side-slabs',       desc: 'Wing / side slab attach' },
  { label: 'Slope Details',         dialog: 'slope-details',    desc: 'Drain slope specifications' },
  { label: 'Brace Points',          dialog: 'brace-points',     desc: 'Temporary bracing insert locations' },
  { label: 'Pick Points',           dialog: 'pick-points',      desc: 'Crane pick insert locations' },
  { label: 'Weld Connections',      dialog: 'weld-connections', desc: 'Weld plate / embed locations' },
  { label: 'Change Thickness',      dialog: 'change-thickness', desc: 'Override panel thickness' },
  { label: 'Panel Attributes',      dialog: 'panel-attributes', desc: 'Quantity, finish, sealer info' },
];

export default function PanelOptionsDialog() {
  const setActiveDialog = useStore(s => s.setActiveDialog);

  return (
    <DialogBase title="Panel Options" hideFooter>
      <div className="options-grid">
        {OPTIONS.map(o => (
          <button
            key={o.dialog}
            className="options-item"
            onClick={() => setActiveDialog(o.dialog)}
            title={o.desc}
          >
            <span className="options-label">{o.label}</span>
            <span className="options-desc">{o.desc}</span>
          </button>
        ))}
      </div>
    </DialogBase>
  );
}
